import { ref, computed } from 'vue';
import { getTodayForAPI } from '@/utils/dateUtil';

/**
 * 채권 설정 페이지의 탭 및 메뉴 관리를 위한 컴포저블
 */
export function useBondSetting() {
  // States
  const currentBondType = ref('KTB');
  const currentSubMenu = ref('basic');
  const selectedDate = ref(getTodayForAPI()); // 선택된 기준일자

  // Constants
  const bondTypes = ['KTB', 'MSB', 'CREDIT'];

  // 채권 타입별 하위 메뉴 설정
  const menuConfig = {
    KTB: [
      { key: 'basic', title: '기본정보', icon: 'fas fa-info-circle' }
    ],
    MSB: [
      { key: 'basic', title: '기본정보', icon: 'fas fa-info-circle' }
    ],
    CREDIT: [
      { key: 'basic', title: '기본정보', icon: 'fas fa-info-circle' },
      { key: 'issuance', title: '발행정보', icon: 'fas fa-file-invoice' },
      { key: 'issuer', title: '발행사 관리', icon: 'fas fa-building' },
      { key: 'group', title: '그룹 관리', icon: 'fas fa-layer-group' },
    ],
  };

  // 채권 타입별 제목 매핑
  const bondTypeTitles = {
    KTB: '국고채',
    MSB: '통안채',
    CREDIT: '크레딧',
  };

  // 채권 타입별 아이콘 매핑
  const bondTypeIcons = {
    KTB: 'fas fa-landmark',
    MSB: 'fas fa-university',
    CREDIT: 'fas fa-chart-line',
  };

  // Computed
  const currentMenus = computed(() => {
    return menuConfig[currentBondType.value] || [];
  });

  // Methods
  const getBondTypeTitle = (type) => {
    return bondTypeTitles[type] || type;
  };

  const getBondTypeIcon = (type) => {
    return bondTypeIcons[type] || 'fas fa-circle';
  };

  const selectBondType = (type) => {
    if (!bondTypes.includes(type)) {
      console.warn(`Invalid bond type: ${type}`);
      return;
    }

    currentBondType.value = type;
    // 채권 타입 변경 시 첫 번째 하위 메뉴로 이동
    const firstMenu = menuConfig[type]?.[0];
    if (firstMenu) {
      currentSubMenu.value = firstMenu.key;
    }
  };

  const selectSubMenu = (menuKey) => {
    const availableMenus = currentMenus.value.map(menu => menu.key);
    if (!availableMenus.includes(menuKey)) {
      console.warn(`Invalid menu key: ${menuKey} for bond type: ${currentBondType.value}`);
      return;
    }

    currentSubMenu.value = menuKey;
  };

  const isCurrentBondType = (type) => {
    return currentBondType.value === type;
  };

  const isCurrentSubMenu = (menuKey) => {
    return currentSubMenu.value === menuKey;
  };

  const selectDate = (date) => {
    selectedDate.value = date;
  };

  // Initialize with default values
  const initialize = (defaultBondType = 'KTB', defaultSubMenu = 'basic') => {
    selectBondType(defaultBondType);
    if (menuConfig[defaultBondType]?.some(menu => menu.key === defaultSubMenu)) {
      currentSubMenu.value = defaultSubMenu;
    }
  };

  return {
    // States
    currentBondType,
    currentSubMenu,
    bondTypes,
    selectedDate,
    
    // Computed
    currentMenus,
    
    // Methods
    getBondTypeTitle,
    getBondTypeIcon,
    selectBondType,
    selectSubMenu,
    isCurrentBondType,
    isCurrentSubMenu,
    selectDate,
    initialize,
  };
} 